<template>
  <div>
    <transition name="fade" mode="out-in">
      <app-loading
        class="fullscreen"
        :is-loading="true"
        :spinner-color="'#1474a4'"
      />
    </transition>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'udi-return',

    computed: {
      ...mapGetters('account', ['isAuthenticated'])
    },

    methods: {
      ...mapActions('account', ['loginUdi']),

      commonJumpRoute () {
        const lastBundle = window.localStorage.getItem('lastBundle')
        this.$router.replace({
          path: '/checkout',
          query: {
            bundle: lastBundle
          }
        })
      },

      async handleLogin () {
        const { user, loginState } = await this.$udiAuth.loginCallback()
        if (user && !user.expired) {
          let data = {}
          try {
            data = await this.loginUdi({ accessToken: user.access_token })
          } catch (e) {
            this.$notify({
              type: 'error',
              title: extractErrorMessage(e)
            })
            await this.$udiAuth.logout()
          }

          if (loginState.returnUrl && (!loginState.email || loginState.email === data.details.email)) {
            this.$router.replace({ path: loginState.returnUrl })
          } else {
            this.commonJumpRoute()
          }
        }
      }
    },

    async mounted () {
      if (window.top !== window) {
        await this.$udiAuth.loginSlientCallback(window.location.href)
        return
      }
      const state = this.$route.query.state
      if (state) {
        await this.handleLogin()
      } else {
        if (this.isAuthenticated) {
          const accessToken = await this.$udiAuth.getToken()
          if (accessToken) {
            await this.$api.account.updateProfile({ accessToken })
            this.$router.replace({ path: '/my-account/personal-details' })
            return
          } else {
            this.$store.dispatch('account/logout')
          }
        }
        this.commonJumpRoute()
      }
    }
  }
</script>
